import { textLengths } from "../../redux/Types";

export const validateAaminOverride = (data) => {
    let errors = {};
    if (data) {

      if (!data.toStatus) {
        errors.toStatus = " Status should not be empty.";
      }
     
      if (data.withNotes?.length && data.withNotes.length > textLengths.TEXT) {
        errors.withNotes = "Notes should be less than 256 characters.";
      }
      
    }
    if (Object.entries(errors).length === 0) {
      return null;
    } else {
      return errors;
    }
};